/**
 * Correctly stringifies a query object into a URL query string,
 * handling array values by creating multiple keys.
 * @param query - A record object similar to Vue Router's $route.query.
 * @returns A URL-encoded query string.
 */
export function stringifyQuery(query: Record<string, any>): string {
  const params = new URLSearchParams();

  for (const key in query) {
    // Ensure the key belongs to the object, not its prototype
    if (Object.hasOwn(query, key)) {
      const value = query[key];

      // Skip null or undefined values so they don't appear as `key=`
      if (value === null || value === undefined) {
        continue;
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          // Also ensure array items are not null/undefined
          if (item !== null && item !== undefined) {
            params.append(key, String(item));
          }
        });
      } else {
        params.set(key, String(value));
      }
    }
  }
  return params.toString();
}
